import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import Connect from './pages/Connect'
import TradeBuilder from './pages/TradeBuilder'
import TradeExplorer from './pages/TradeExplorer'
import TradeResult from './pages/TradeResult'
import SharedTrade from './pages/SharedTrade'
import TradesList from './pages/TradesList'

export default function App() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <Routes>
        <Route path="/" element={<Navigate to="/connect" replace />} />
        <Route path="/connect" element={<Connect />} />
        <Route path="/leagues/:leagueId/trade" element={<TradeBuilder />} />
        <Route path="/leagues/:leagueId/explore" element={<TradeExplorer />} />
        <Route path="/trades" element={<TradesList />} />
        <Route path="/trades/:tradeId" element={<TradeResult />} />
        <Route path="/s/:token" element={<SharedTrade />} />
      </Routes>
    </div>
  )
}
